import React from 'react';
import { Button, Descriptions, Space } from 'antd';
import { User, roleNameKoreanEnum } from '../../modules/auth';
import styled from 'styled-components';
import { styledDescriptions } from '../styled/mixin';
import { phoneFormatter } from '../../util/utils';

const StyledDiv = styled.div`
  ${styledDescriptions}
`;

interface ProfileDetailComponentProps {
  data: User;
  goMainPage: () => void;
  goEditPage: () => void;
  goPasswordResetPage: () => void;
  deleteUserAccount: () => void;
  updateUserPhone: () => void;
  connectToModusign: () => void;
  disconnectToModusign: () => void;
}

function ProfileDetailComponent({
  data,
  goMainPage,
  goEditPage,
  goPasswordResetPage,
  deleteUserAccount,
  updateUserPhone,
  connectToModusign,
  disconnectToModusign,
}: ProfileDetailComponentProps) {
  return (
    <StyledDiv>
      <div>
        <Descriptions
          title="기본 정보"
          bordered
          column={2}
          size="small"
          extra={
            <Space>
              <Button onClick={() => goPasswordResetPage()}>
                비밀번호 재설정
              </Button>
              <Button onClick={() => updateUserPhone()}>
                휴대전화번호 수정
              </Button>
              <Button onClick={() => goEditPage()}>수정</Button>
              {/* <Button onClick={() => deleteUserAccount()}>계정 삭제</Button> */}
            </Space>
          }
        >
          <Descriptions.Item label="이름">{data.name}</Descriptions.Item>
          <Descriptions.Item label="이메일">{data.email}</Descriptions.Item>
          <Descriptions.Item label="소속">{data.team}</Descriptions.Item>
          <Descriptions.Item label="직책">
            {data.workPosition}
          </Descriptions.Item>
          <Descriptions.Item label="역할">
            {roleNameKoreanEnum[data.roleName]}
          </Descriptions.Item>
          <Descriptions.Item label="연락처(회사)">
            {phoneFormatter(data.workPhone, 1)}
          </Descriptions.Item>
          <Descriptions.Item label="연락처(개인)">
            {phoneFormatter(data.personalPhone, 1)}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </StyledDiv>
  );
}

export default ProfileDetailComponent;
